<template>
  <div class="loading" v-if="loading">
    <loading />
  </div>
  <line-chart
    v-else
    :height="height"
    :prop-map="propMap"
    :view-model="dataEx"
    :tooltip-formater="tooltipRender"
    tooltip-class="order-line-chart-tooltip"
  />
</template>
<script>
import { LoadOrderStatistic } from '../services'
import LineChart from '@/components/OrderChart.vue'
import Loading from '@/components/Loading.vue'
import { Exporter as ExcelExporter } from '@/libs/excelfile'
import moment from 'moment'
import _ from 'lodash'
export default {
  name: 'OrderLineChart',
  props: {
    timeSpan: {
      type: Object,
      default () {
        return {
          range: null,
          rangeType: 'daterange'
        }
      }
    },
    height: {
      type: String,
      default () {
        return '300px'
      }
    }
  },
  components: { LineChart, Loading },
  data () {
    return {
      loading: true,
      dataEx: [],
      data: [],
      propMap: {
        xAxis: 'date',
        benz: '奔驰系',
        bmw: '宝马系',
        jaguar: '捷豹路虎',
        audi: '大众系',
        gmw: '通用系',
        other: '其他'
      },
      mapReverse: {
        '奔驰系': 'benz',
        '宝马系': 'bmw',
        '捷豹路虎': 'jaguar',
        '大众系': 'audi',
        '通用系': 'gmw',
        '其他': 'other'
      }
    }
  },
  computed: {
    startDay () {
      if (this.timeSpan.range) {
        return moment(this.timeSpan.range[0]).format('YYYY-MM-DD')
      }
      return undefined
    },
    endDay () {
      if (this.timeSpan.range) {
        return moment(this.timeSpan.range[1]).format('YYYY-MM-DD')
      }
      return undefined
    },
    priceType () {
      return this.timeSpan.partType
    },
    periodType () {
      return this.timeSpan.rangeType === 'daterange' ? 1 : 0
    }
  },
  watch: {
    priceType () {
      this.$nextTick(() => {
        this.processPriceType()
      })
    },
    periodType () {
      this.loadDataDebounce()
    },
    startDay () {
      this.loadDataDebounce()
    },
    endDay () {
      this.loadDataDebounce()
    },
    newAdd () {
      this.loadDataDebounce()
    },
    area () {
      this.loadDataDebounce()
    }
  },
  created () {
    this.loadDataDebounce = _.debounce(() => {
      this.loadData()
    }, 30)
  },
  mounted () {
    this.$nextTick(() => {
      this.$on('exportExcel', () => {
        this.expData()
      })
    })
    this.loadDataDebounce()
  },
  methods: {
    expData () {
      const mergeInfo = []
      const options = {
        '!cols': [
          { wpx: 60 },
          { wpx: 60 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 }
        ]
      }
      const exportData = []
      exportData.push(
        ['日期', '品牌', '销售', '订单笔数', '退款', '退款笔数', '急件', '急件笔数', '急件退', '急件退款笔数', '含税', '含税笔数', '含税退', '含税退款笔数']
      )
      const props = [ 'benz', 'bmw', 'jaguar', 'audi', 'gmw', 'other' ]
      this.data.forEach(t => {
        props.forEach(b => {
          exportData.push(
            [ t.date, this.propMap[b], t[b + 'All'], t[b + 'CountAll'], t[b + 'ReturnAll'], t[b + 'CountReturnAll'], t[b + 'Ji'], t[b + 'CountJi'], t[b + 'JiReturn'], t[b + 'CountReturnJi'], t[b + 'Tax'], t[b + 'CountTax'], t[b + 'TaxReturn'], t[b + 'CountReturnTax'] ]
          )
        })
      })
      return ExcelExporter(
        exportData,
        mergeInfo,
        `兆配云销售统计_${moment().format('YYYYMMDDHHmmss')}.xlsx`,
        '销售统计',
        options
      ).catch(() => {
        this.$message.error('导出失败')
      }).finally(() => {
        this.loading = false
      })
    },
    loadData () {
      this.loading = true
      LoadOrderStatistic({
        newAdd: this.newAdd,
        area: this.area || undefined,
        startDay: this.startDay,
        endDay: this.endDay,
        dayPeriod: this.periodType === 1
      }).then(resp => {
        this.data = resp
        this.processPriceType()
      }).finally(() => {
        this.loading = false
      })
    },
    processPriceType () {
      const props = [ 'benz', 'bmw', 'jaguar', 'audi', 'gmw', 'other' ]
      this.dataEx.splice(0)
      if (this.priceType === '1') {
        const newDataEx = this.data.map(t => {
          let nt = { ...t }
          props.forEach(p => {
            nt[p] = nt[p + 'Ji']
            nt[p + 'Return'] = nt[p + 'JiReturn']
            nt[p + 'Count'] = nt[p + 'CountJi']
            nt[p + 'CountReturn'] = nt[p + 'CountReturnJi']
          })
          return nt
        })
        this.dataEx.push(...newDataEx)
      } else if (this.priceType === '2') {
        const newDataEx = this.data.map(t => {
          let nt = { ...t }
          props.forEach(p => {
            nt[p] = nt[p + 'Tax']
            nt[p + 'Return'] = nt[p + 'TaxReturn']
            nt[p + 'Count'] = nt[p + 'CountTax']
            nt[p + 'CountReturn'] = nt[p + 'CountReturnTax']
          })
          return nt
        })
        this.dataEx.push(...newDataEx)
      } else {
        const newDataEx = this.data.map(t => {
          let nt = { ...t }
          props.forEach(p => {
            nt[p] = nt[p + 'All']
            nt[p + 'Return'] = nt[p + 'ReturnAll']
            nt[p + 'Count'] = nt[p + 'CountAll']
            nt[p + 'CountReturn'] = nt[p + 'CountReturnAll']
          })
          return nt
        })
        this.dataEx.push(...newDataEx)
      }
    },
    tooltipRender (params, ticket) {
      const dateData = this.dataEx.find(t => t.date === params[0].axisValue)
      let rowHtml = ''
      let totalReturnAmount = 0
      let totalAmount = 0
      let allTotalCount = 0
      let allTotalReturnCount = 0
      params.forEach(element => {
        if (element.componentSubType !== 'line') {
          return
        }
        let totalCount = 0
        let totalCountReturn = 0
        totalAmount += element.data
        const returnAmount = dateData[this.mapReverse[element.seriesName] + 'Return']
        const count = dateData[this.mapReverse[element.seriesName] + 'Count']
        const countReturn = dateData[this.mapReverse[element.seriesName] + 'CountReturn']
        totalCount += count
        allTotalCount += count
        totalReturnAmount += returnAmount
        totalCountReturn += countReturn
        allTotalReturnCount += countReturn
        rowHtml += `
        <div class="serie-item">
          <div style="--serie-color:${element.color}">
            <div class="serie-color-block"></div>
          </div>
          <div>
            ${element.seriesName}
          </div>
          <div>
            ${element.data}&nbsp;(${totalCount}笔)
          </div>
          <div>
            ${returnAmount}&nbsp;(${totalCountReturn}笔)
          </div>
          <div>${(element.data - returnAmount).toFixed(2)}</div>
        </div>
        `
      })
      const totalRemainAmount = totalAmount - totalReturnAmount
      return `
<div>
  <div class="date">${params[0].axisValue}</div>
  <div class="serie-item top">
    <div></div>
    <div>品牌</div>
    <div>销售</div>
    <div>退款</div>
    <div>小计</div>
  </div>
  ${rowHtml}
  <div class="serie-item total">
    <div></div>
    <div>合计：</div>
    <div>${totalAmount.toFixed(2)}&nbsp;(${allTotalCount}笔)</div>
    <div>${totalReturnAmount.toFixed(2)}&nbsp;(${allTotalReturnCount}笔)</div>
    <div>${totalRemainAmount.toFixed(2)}</div>
  </div>
</div>
      `
    }
  }
}
</script>
